"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTransactionWithAPI = void 0;
const web3_1 = require("./api/chain/web3");
const utils_1 = require("./utils");
const web3_js_1 = require("@solana/web3.js");
const buildTransactionWithAPI = (account, transaction, api) => __awaiter(void 0, void 0, void 0, function* () {
    const instructions = buildInstructions(transaction);
    const recentBlockhash = yield api.getLatestBlockhash();
    const feePayer = new web3_js_1.PublicKey(account.freshAddress);
    const tm = new web3_js_1.TransactionMessage({
        payerKey: feePayer,
        recentBlockhash,
        instructions,
    });
    const tx = new web3_js_1.VersionedTransaction(tm.compileToLegacyMessage());
    return [
        tx,
        (signature) => {
            tx.addSignature(new web3_js_1.PublicKey(account.freshAddress), signature);
            return tx;
        },
    ];
});
exports.buildTransactionWithAPI = buildTransactionWithAPI;
function buildInstructions(tx) {
    const { commandDescriptor } = tx.model;
    if (commandDescriptor === undefined) {
        throw new Error("missing command descriptor");
    }
    if (Object.keys(commandDescriptor.errors).length > 0) {
        throw new Error("can not build invalid command");
    }
    return buildInstructionsForCommand(commandDescriptor.command);
}
function buildInstructionsForCommand(command) {
    switch (command.kind) {
        case "transfer":
            return (0, web3_1.buildTransferInstructions)(command);
        case "token.transfer":
            return (0, web3_1.buildTokenTransferInstructions)(command);
        case "token.createATA":
            return (0, web3_1.buildCreateAssociatedTokenAccountInstruction)(command);
        case "stake.createAccount":
            return (0, web3_1.buildStakeCreateAccountInstructions)(command);
        case "stake.delegate":
            return (0, web3_1.buildStakeDelegateInstructions)(command);
        case "stake.undelegate":
            return (0, web3_1.buildStakeUndelegateInstructions)(command);
        case "stake.withdraw":
            return (0, web3_1.buildStakeWithdrawInstructions)(command);
        case "stake.split":
            return (0, web3_1.buildStakeSplitInstructions)(command);
        default:
            return (0, utils_1.assertUnreachable)(command);
    }
}
//# sourceMappingURL=js-buildTransaction.js.map